function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 11h32v19H4V11zm3.2 3.167h3.84m-3.84-.254v4.18m26.24 9.5H29.6m3.84.254v-4.18",
  stroke: "#000",
  strokeWidth: "2",
  fill: "none"
})));